import React from "react";
import { styled } from "@mui/material";
import { buttonBg } from "../../constants/colors";

const ItemContainer = styled("div")(({ theme }) => ({
  display: "flex",
  // flex: "0 0 548px",
  // margin: '0 10px; /* Margin between slides */
  transition: "transform 0.5s ease-in-out",
  flexDirection: "column",
  justifyContent: "space-between",
  margin: "10px",
  // width: "100%", // Set a fixed width
  // width: "400px",
  width: "100%",
  height: "100%",
  // [theme.breakpoints.up("lg")]: {
  //   minWidth: "548px", // Adjust these values as needed
  //   width: "548px", // Adjust these values as needed
  // },
  // [theme.breakpoints.between("md", "lg")]: {
  //   minWidth: "322px",
  //   width: "322px",
  // },
  // [theme.breakpoints.down("sm")]: {
  //   minWidth: "310px",
  //   width: "310px",
  // },
}));

const ItemImg = styled("img")(({ theme }) => {
  const breakpoints = theme.breakpoints;
  const imgWidth = {
    [breakpoints.up("lg")]: "548px",
    [breakpoints.between("md", "lg")]: "322px",
    [breakpoints.down("sm")]: "310px",
  };
  const imgHeight = {
    [breakpoints.up("lg")]: "411px",
    [breakpoints.between("md", "lg")]: "241px",
    [breakpoints.down("sm")]: "232px",
  };

  return {
    objectFit: "cover",
    [theme.breakpoints.up("md")]: {
      width: "548px", // Adjust these values as needed
      height: "411px",
    },
    [theme.breakpoints.between("sm", "md")]: {
      width: "322px",
      height: "241px",
    },
    [theme.breakpoints.down("sm")]: {
      width: "310px",
      height: "232px",
    },
  };
});

const ItemTitle = styled("h2")(({ theme }) => ({
  fontFamily: "Roboto Slab",
  fontWeight: "600",
  color: buttonBg,
  textAlign: "center",
  marginBottom: "12px",
  marginTop: "12px",
}));

const ItemDesc = styled("p")(({ theme }) => ({
  fontFamily: "Roboto Slab",
  fontWeight: "400",
  color: buttonBg,
  textAlign: "center",
  marginTop: "0px",
  padding: "0px 20px",
}));

export default function Item({ img, title, desc }) {
  return (
    <ItemContainer>
      <ItemImg src={img} />
      <ItemTitle>{title}</ItemTitle>
      <ItemDesc>{desc}</ItemDesc>
    </ItemContainer>
  );
}
